import axios from 'axios';
import moment from 'moment';
import MitKeyTypeService from './MitKeyTypeService.js';

class MitBorrowService {
  constructor() {
      this.keyTypesService = new MitKeyTypeService();

      this.KEY_TYPES = this.keyTypesService.KEY_TYPES;
      this.KEY_TYPES_DEFAULT = this.KEY_TYPES.change_key;
      this.KEY_TYPES_ARRAY = this.keyTypesService.KEY_TYPES_ARRAY;

  }
  adaptUpdateAccessSpacesDisplay(key){
    const spaceName = [];
    for(let x = 0; x < key.spaces.length; x++){
      spaceName.push(key.spaces[x].mitId)
    }

    key.spacesDisplay = spaceName;
  }
  adaptToUIModel(keys){
    for(let x = 0; x < keys.length; x++){
      keys[x].type = this.KEY_TYPES[keys[x].type];//replace with UI type.
      keys[x].dates_local = {
        checkoutDt: moment(keys[x].checkoutDt).local().format('MMM DD YYYY'),
        //checkoutDt: moment(keys[x].checkoutDt).local().fromNow(),
        returnDt: keys[x].returnDt != null ? moment(keys[x].returnDt).local().fromNow() : null
      };
      //create a flat list of names that should NOT be edited, this is just a read only list for display purposes
      this.adaptUpdateAccessSpacesDisplay(keys[x])
    }

    return keys;
  }
  apaptToAPIModel(keys){
    for(let x = 0; x < keys.length; x++){
      keys[x].type = keys[x].type.id;
      delete keys[x].dates_local;
      delete keys[x].spacesDisplay;
    }

    return keys;
  }

  requestGetBorrowedKeys() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/keys/manager/borrowed')
        .then((response) => {

            return resolve(this.adaptToUIModel(response.data.borrowed));
        })
        .catch((error) => {
          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }
  requestGetBorrowedKeysByOwnerId(ownerId) {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/keys/manager/borrowed/'+ownerId)
        .then((response) => {
            return resolve(this.adaptToUIModel(response.data.borrowed));
        })
        .catch((error) => {
          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }
  requestGetMyBorrowedKeys() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/keys/user/borrowed/my')
        .then((response) => {
            return resolve(this.adaptToUIModel(response.data.borrowed));
        })
        .catch((error) => {
          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }
  requestBorrowKey(borrowModel) {
    return new Promise ((resolve, reject) => {

      axios.post('/api/v1/keys/manager/borrow/key', borrowModel)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }
  requestBorrowKeys(borrowModels) {
    return new Promise ((resolve, reject) => {

      axios.post('/api/v1/keys/manager/borrow/keys', borrowModels)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  requestReturnKeys(ids, isLost) {
    isLost = isLost || false;
    return new Promise ((resolve, reject) => {
      axios.post('/api/v1/keys/manager/return/keys', {ids: ids, isLost:isLost})
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  requestReturnLostKeys(ids, isLost) {
    isLost = isLost || false;
    return new Promise ((resolve, reject) => {
      axios.post('/api/v1/keys/manager/return/keys', {ids: ids, isLost:isLost})
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }


}

export default new MitBorrowService();
